import { useApi } from "#hooks/useApi"
import { jobProfileGet } from "#job-profile/services/api"
import { useMemo } from "react"
import { InputAutocompleteId } from "./InputAutocompleteId"

/**
 * Componente InputAutocompleteJobProfileId.
 *
 * @description
 * Componente basado en MUI Autocomplete que permite seleccionar un perfil de puesto.
 *
 * @param {Object} props - Propiedades del componente.
 * @param {string} props.label - Texto que se mostrará como label del input.
 * @param {any} props.value - Valor actualmente seleccionado.
 * @param {function} props.setValue - Función para actualizar el valor seleccionado.
 * @param {boolean} [props.autoFetch=true] - Indica si se deben cargar los datos automáticamente al montar el componente.
 *
 * @returns {JSX.Element} Componente Autocomplete para seleccionar un área.
 */
export function InputAutocompleteJobProfileId({
	label,
	value,
	setValue,
	autoFetch = true,
}) {
	const params = useMemo(() => ({ list: true }), [])
	const { data: profiles, loading } = useApi(jobProfileGet, { autoFetch, params }, params)

	return (
		<InputAutocompleteId
			data={profiles?.data || []}
			label={label ?? "Perfil Puesto"}
			value={value}
			setValue={setValue}
			loading={loading}
			dataLabel="nombre"
		/>
	)
}
